import React from "react";
import ReactPlaceholder from "react-placeholder";

const Placeholder = ({ ready, children }) => {
  return (
    <ReactPlaceholder
      customPlaceholder={
        <div className="animated fadeIn pt-1 text-center">
          <i className="fa fa-spinner fa-spin" /> Carregando
        </div>
      }
      ready={ready}
    >
      {children}
    </ReactPlaceholder>
  );
};

export default Placeholder;
